import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-559b141b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "new-company-form__block-head" }
const _hoisted_3 = { class: "new-company-form__title-wrapper" }
const _hoisted_4 = { class: "new-company-form__block-title" }
const _hoisted_5 = { class: "new-company-form__row new-company-form__row--three-cols" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = { class: "new-company-form__block-head" }
const _hoisted_8 = { class: "new-company-form__title-wrapper" }
const _hoisted_9 = { class: "new-company-form__block-title" }
const _hoisted_10 = { class: "new-company-form__row new-company-form__row--1-1" }
const _hoisted_11 = { class: "new-company-form__row new-company-form__row--two-cols" }

import { reactive, ref } from 'vue'
import { FORMATS } from '@/enums/components'
import BaseInput from '@/components/BaseInput.vue'
import BaseButton from '@/components/BaseButton.vue'
import BaseAddressSearch from '@/components/BaseAddressSearch.vue'
import CountrySelect from '@/components/CountrySelect.vue'
import CompanyFinder from '@/components/CompanyFinder.vue'
import ServiceProviderContractCheckbox from '@/components/settings/ServiceProviderContractCheckbox.vue'
import { useToast } from 'vue-toastification'
import { useI18n } from 'vue-i18n'
import axios from 'axios'
import { useAddCompanyMutation } from '@/queries/companies.queries'
import { NewCompanyPayload } from '@/models/company.model'
import { AddressDetailsPayload } from '@/models/location.model'
import BaseIcon from '@/components/BaseIcon.vue'
import { useAuthStore } from '@/store/auth'
import { AriregisterRegister } from '@/models/ariregister.model'
import { COUNTRY_ID } from '@/enums/settings'
import { getDefaultRegistrationCountry } from '@/utils/general'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormCreateCompany',
  emits: ['close', 'change'],
  setup(__props, { emit: emits }) {

const form = reactive<NewCompanyPayload>({
  company: {
    reg_code: '',
    name: '',
    email: '',
    phone: '',
    reg_country: getDefaultRegistrationCountry(),
    vat_number: '',
    is_agreed_contract: false,
  },
  address: {
    state: '',
    city: '',
    city_region: '',
    street: '',
    house: '',
    apartment: '',
    postal_code: '',
    full_address: '',
  },
})

const authStore = useAuthStore()
const i18n = useI18n()
const toast = useToast()
const errors = ref()


const { isLoading, mutateAsync } = useAddCompanyMutation()

const submitForm = async () => {
  try {
    errors.value = undefined
    const newCompany = await mutateAsync(form)
    authStore.addCompany(newCompany)
    authStore.selectCompany(newCompany.id)
    toast.success(i18n.t('companyCreated'))

    emits('close')
  } catch (error) {
    console.error(error)
    toast.error(i18n.t('companyCreationError'))
    if (axios.isAxiosError(error) && error?.response?.status === 400) {
      errors.value = error?.response?.data
      const modal = document.getElementById('modalContainer')
      if (modal) modal.scrollTop = 0
    }
  }
}

const updateAddress = (value) => {
  errors.value = null
  form.address.full_address = value
}

function onCompanyClicked(companyDetails: AriregisterRegister) {
  Object.assign(form.address, companyDetails.address)
  Object.assign(form.company, companyDetails.company)
}

function onGoogleAddressClicked(addressDetails: AddressDetailsPayload) {
  Object.assign(
    form.address,
    { state: addressDetails.county },
    { city: addressDetails.city },
    { street: addressDetails.street },
    { house: addressDetails.number },
    { postal_code: addressDetails.zip_code },
    { full_address: addressDetails.google_address },
  )
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "new-company-form",
    onSubmit: _withModifiers(submitForm, ["prevent"])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BaseIcon, {
          class: "new-company-form__icon",
          icon: "buildings",
          width: 24,
          height: 24
        }),
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t('businessInfo')), 1)
      ])
    ]),
    _createVNode(CountrySelect, {
      modelValue: form.company.reg_country,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.company.reg_country) = $event)),
      label: _ctx.$t('registrationCountry'),
      placeholder: _ctx.$t('selectCountry'),
      name: "company_country",
      errors: errors.value?.company?.reg_country,
      onSelect: _cache[1] || (_cache[1] = (value) => _ctx.$emit('change', (form.company.reg_country = value)))
    }, null, 8, ["modelValue", "label", "placeholder", "errors"]),
    (form.company.reg_country !== _unref(COUNTRY_ID).ESTONIA)
      ? (_openBlock(), _createBlock(BaseInput, {
          key: 0,
          modelValue: form.company.name,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.company.name) = $event)),
          label: _ctx.$t('name'),
          name: "company_name",
          type: "tel",
          errors: errors.value?.company?.name
        }, null, 8, ["modelValue", "label", "errors"]))
      : (_openBlock(), _createBlock(CompanyFinder, {
          key: 1,
          "model-value": form.company.name,
          placeholder: _ctx.$t('registration.searchCompany'),
          "reg-country": form.company.reg_country,
          errors: errors.value?.company.name,
          onOptionClick: onCompanyClicked,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = (value) => (form.company.name = value))
        }, null, 8, ["model-value", "placeholder", "reg-country", "errors"])),
    _createVNode(BaseInput, {
      modelValue: form.company.email,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.company.email) = $event)),
      label: _ctx.$t('email'),
      name: "company_email",
      type: "tel",
      errors: errors.value?.company?.email
    }, null, 8, ["modelValue", "label", "errors"]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(BaseInput, {
        modelValue: form.company.phone,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.company.phone) = $event)),
        label: _ctx.$t('phone'),
        name: "company_phone",
        type: "tel",
        class: "new-company-form__input--half-width",
        errors: errors.value?.company?.phone
      }, null, 8, ["modelValue", "label", "errors"]),
      _createVNode(BaseInput, {
        modelValue: form.company.reg_code,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.company.reg_code) = $event)),
        label: _ctx.$t('registryNumber'),
        name: "reg_code",
        type: "text",
        class: "new-company-form__input--half-width",
        errors: errors.value?.company?.reg_code
      }, null, 8, ["modelValue", "label", "errors"]),
      _createVNode(BaseInput, {
        "model-value": form.company.vat_number,
        label: _ctx.$t('vat_number'),
        errors: errors.value?.company?.vat_number,
        name: "company_vat_number",
        type: "text",
        "onUpdate:modelValue": _cache[7] || (_cache[7] = 
          (value) => (form.company.vat_number = value.toUpperCase())
        )
      }, null, 8, ["model-value", "label", "errors"])
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(BaseIcon, {
          class: "new-company-form__icon",
          icon: "map-pin",
          width: 24,
          height: 24
        }),
        _createElementVNode("h4", _hoisted_9, _toDisplayString(_ctx.$t('address')), 1)
      ])
    ]),
    _createVNode(BaseAddressSearch, {
      placeholder: _ctx.$t('Search for address'),
      result: form.address?.full_address,
      errors: errors.value?.address?.full_address,
      onOptionClick: onGoogleAddressClicked,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = (value) => updateAddress(value))
    }, null, 8, ["placeholder", "result", "errors"]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(BaseInput, {
        modelValue: form.address.state,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.address.state) = $event)),
        label: _ctx.$t('state'),
        name: "state",
        type: "text",
        class: "new-company-form__input--half-width",
        errors: errors.value?.address?.state
      }, null, 8, ["modelValue", "label", "errors"]),
      _createVNode(BaseInput, {
        modelValue: form.address.city,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.address.city) = $event)),
        label: _ctx.$t('city'),
        name: "city",
        type: "text",
        class: "new-company-form__input--half-width",
        errors: errors.value?.address?.city
      }, null, 8, ["modelValue", "label", "errors"])
    ]),
    _createVNode(BaseInput, {
      modelValue: form.address.city_region,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.address.city_region) = $event)),
      label: _ctx.$t('cityRegion'),
      name: "city_region",
      type: "text",
      errors: errors.value?.address?.city_region
    }, null, 8, ["modelValue", "label", "errors"]),
    _createVNode(BaseInput, {
      modelValue: form.address.street,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.address.street) = $event)),
      label: _ctx.$t('street'),
      name: "street",
      type: "text",
      errors: errors.value?.address?.street
    }, null, 8, ["modelValue", "label", "errors"]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(BaseInput, {
        modelValue: form.address.house,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.address.house) = $event)),
        label: _ctx.$t('house'),
        name: "house",
        type: "text",
        class: "new-company-form__input--half-width",
        errors: errors.value?.address?.house
      }, null, 8, ["modelValue", "label", "errors"]),
      _createVNode(BaseInput, {
        modelValue: form.address.apartment,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.address.apartment) = $event)),
        label: _ctx.$t('apartment'),
        name: "apartment",
        type: "text",
        class: "new-company-form__input--half-width",
        errors: errors.value?.address?.apartment
      }, null, 8, ["modelValue", "label", "errors"])
    ]),
    _createVNode(BaseInput, {
      modelValue: form.address.postal_code,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.address.postal_code) = $event)),
      label: _ctx.$t('zipCode'),
      name: "postal_code",
      type: "text",
      errors: errors.value?.address?.postal_code
    }, null, 8, ["modelValue", "label", "errors"]),
    _createVNode(ServiceProviderContractCheckbox, {
      modelValue: form.company.is_agreed_contract,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.company.is_agreed_contract) = $event)),
      errors: errors.value?.company.is_agreed_contract
    }, null, 8, ["modelValue", "errors"]),
    _createVNode(BaseButton, {
      class: "new-company-form__button",
      label: _ctx.$t('create'),
      loading: _unref(isLoading),
      format: _unref(FORMATS).PRIMARY,
      onClick: _withModifiers(submitForm, ["prevent"])
    }, null, 8, ["label", "loading", "format", "onClick"])
  ], 40, _hoisted_1))
}
}

})